module.exports = __webpack_public_path__ + "images/assets/b25518df71755dfef3ff5012d9f83516.svg";